// supabaseClient.js

import { createClient } from '@supabase/supabase-js';

console.log('import', process.env);

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL; 
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY; 

const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;